import * as Yup from 'yup';
import { IValidation } from '../../models/components/validation-props';
import { DefaultValidation } from './main-validations';

export function getValidation(props?: IValidation) {
    
    const defaultValidation = new DefaultValidation(props);

    return Yup.object().shape({
        defaultValuesFormik: defaultValidation.SetDefaultValues(),
        isFileUploadEmpty: defaultValidation.GetIsFileUploadEmpty(),
        name: defaultValidation.GetName(),
        dateRange: defaultValidation.GetDateRange(),
        datePrerequisiteActivityId: defaultValidation.GetDatePrerequisiteActivityId(),
        selectActivity: defaultValidation.GetSelectActivity(),
        subActivities: defaultValidation.GetSubActivities(),
        activityTime: defaultValidation.GetActivityTime()
    });
}
